import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ITDeleteAccountRequestService } from "../../../../../services/it-delete-account/itDeleteAccountRequest.service";
import { useHistory } from "react-router-dom";
import { notification } from "antd";
import { Routes } from "../../../../../AppRoutes";

export const useCreateDARequest = () => {
  const queryClient = useQueryClient();
  const history = useHistory();

  const { mutate, isLoading } = useMutation({
    mutationFn: (body: any) => ITDeleteAccountRequestService.addITDeleteAccountRequest(body),
  });

  const createDARequest = (body: any, options?: { onSuccess?: (res: any) => void }) => {
    mutate(body, {
      onSuccess(res: any) {
        queryClient.invalidateQueries({ queryKey: ["delete-account-requests"] });
        history.push(Routes.deleteUserAccountDetailPage.path.replace(":id", res.id));
        notification.success({
          message: "Thành công!",
          description: `Tạo yêu cầu thành công.`,
        });
        if (options?.onSuccess) options.onSuccess(res);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: `Tạo yêu cầu thất bại.`,
        });
      },
    });
  };

  return { mutate, createDARequest, isLoading };
};
